const truncateString = (input: string, length: number): string => {
  if (input?.length <= length) {
    return input
  }
  return input?.slice?.(0, length) + "..."
}

export { truncateString }
